import React from 'react';
import ReactInputMask from 'react-input-mask';

export default function InputMask({ className, isInvalid, ...rest }) {
    return (
        <ReactInputMask className={`form-control ${className} ${isInvalid && 'is-invalid'}`} {...rest} />
    )
}